"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = require("react");
var _updaterContext = _interopRequireDefault(require("../../store/updater-context"));
var _RCSequencerManager = _interopRequireDefault(require("../../utils/RCSequencer/RCSequencerManager"));
var _MovementButtonsSection = _interopRequireDefault(require("../MovementButtonsSection"));
var _PadControllerSection = _interopRequireDefault(require("../PadControllerSection"));
require("./styles.css");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const BottomSection = () => {
  const _ = (0, _react.useContext)(_updaterContext.default);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("section", {
    className: "bottom-section",
    style: {
      opacity: _RCSequencerManager.default.isSequenceFull() ? 0.5 : 1
    },
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_PadControllerSection.default, {
      isDeactivated: _RCSequencerManager.default.isSequenceFull()
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_MovementButtonsSection.default, {
      isDeactivated: _RCSequencerManager.default.isSequenceFull()
    })]
  });
};
var _default = exports.default = BottomSection;